import React, { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import InputGroup from "../../components/Input/InputGroup";
import { IoIosSearch } from "react-icons/io";
import CommonContext from "../../hooks/CommonContext";
import { IoChevronBackCircle } from "react-icons/io5";
import Joyride from 'react-joyride';
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";


const FilterMethods = () => {
  //Redux slice picker
  const selectmilleSearchStates = (state) => state.milleSearchStates;
  const selectMemoizedStates = createSelector(
    [selectmilleSearchStates],
    (milleSearchStates) => ({ milleSearchStates })
  );

  const { milleSearchStates } = useSelector(selectMemoizedStates);
  //

  const {
    setapplyFilterResponse, professionalJobClearing, setprofessionalJobClearing, cardArray, professionalJobSearching,
    setSearchResult, getRecommendedData, getAppliedDatas, getSavedDatas, setGettingResponse,
    setSortBy, sendingDataForProfessionalSearch, setCardArray, setAnswer, setSelectedCardData, setRefreshAction,
    selectedCardPath, isSmallDevice, setSelectedCardIndex, setCardArrayDuplicate, setCardArrayDuplicateSearch,
    gettingResponse, searchInput, setSearchInput, setIsSearched, isMellieSearch, skills, sectors, specialization, workplaceType,
    jobTypee, schedule, professionalMellieSearch, isSearched, setFilteringObject, setCurrentPage,
    isSelectedJob, isSharedJob, setIsSharedJob, setIsSelectedJob, getHomeAll
  } = useContext(CommonContext);
  const pageRender = useNavigate();

  const handleSearchInput = (e) => {
    var searchIp = e.target.value;
    setSearchInput(searchIp)
  }

  const handlekeydown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearchUsingApi(e);
    }
  };

  const handleClearSearch = () => {
    const pathname = window.location.pathname;
    setprofessionalJobClearing(true)
    setapplyFilterResponse(true)
    setSearchInput("")
    setSortBy("")

    switch (pathname) {
      case "/professional/all_jobs":
        handleProfessionalMellieSearch("clear")
        break;

      case "/professional/recommended_jobs":
        getRecommendedData()
        break;

      case "/professional/applied_jobs":
        getAppliedDatas();
        break;

      case "/professional/saved_jobs":
        getSavedDatas();
        break;

      default:
        break;
    }
  }

  const handleSearchUsingApi = () => {
    if (searchInput) {
      setSearchResult(true)
      setapplyFilterResponse(true)
      setSortBy("Date Latest")
      setCurrentPage(0)
      setIsSearched(true)

      const pathname = window.location.pathname;
      const obj = {
        search_text: searchInput.trim(),
        page_number: 1
      }

      switch (pathname) {
        case "/professional/all_jobs":
          handleProfessionalMellieSearch("search")
          break;

        case "/professional/recommended_jobs":
          if (cardArray.length > 0) {
            setAnswer([])

            const searchJobs = cardArray.filter((v, i) => {
              return v.job_title.toLowerCase().includes(searchInput.toLowerCase())
            })
            setCardArrayDuplicate(searchJobs)

            setCardArrayDuplicateSearch(searchJobs)
            if (searchJobs.length > 0) {
              setSelectedCardData([searchJobs[0]])

              if (window.location.pathname === "/professional/all_jobs" || window.location.pathname === "/professional/recommended_jobs" || window.location.pathname === "/professional/saved_jobs" || window.location.pathname === "/professional/job_Details") {
                var findJobIndex = cardArray.findIndex((v) => {
                  return v.id === searchJobs[0].id
                })
                setSelectedCardIndex(findJobIndex)
              }

              if (searchJobs[0].questions !== undefined) {
                searchJobs[0].questions.map((v) => {
                  setAnswer((prevState) => [
                    ...prevState,
                    { question_id: v.id, answer: "" },
                  ]);
                });
              }
            } else {
              setSelectedCardData([])
            }
          }

          if (searchInput === '') {
            setAnswer([])
            setCardArrayDuplicate(cardArray)
            setCardArrayDuplicateSearch(cardArray)

            if (cardArray[0].questions !== undefined) {
              cardArray[0].questions.map((v) => {
                setAnswer((prevState) => [
                  ...prevState,
                  { question_id: v.id, answer: "" },
                ]);
              });
            }
          }

          setSearchResult(false)
          setapplyFilterResponse(false)
          break;

        case "/professional/applied_jobs":
          sendingDataForProfessionalSearch("/search_result_applied", obj);
          break;

        case "/professional/saved_jobs":
          sendingDataForProfessionalSearch("/search_result_saved", obj);
          break;

        default:
          break;
      }
    } else {
      toast.error("search field is empty")
    }
  }

  //Professional mellie search
  const handleProfessionalMellieSearch = (type) => {
    if (type === "clear" && !isMellieSearch) {
      getHomeAll()
      setIsSearched(false)
      setprofessionalJobClearing(false)
      return
    }

    let object;
    if (isMellieSearch) {
      const locationConvertion = milleSearchStates?.location.map((v) => {
        const originalVal = v.split(',')
        const joinOriginalValue = originalVal.join('&&&&&')

        return joinOriginalValue
      })

      var a = skills.map((v) => v.label)
      var b = sectors.map((v) => v.label)
      var c = specialization.map((v) => v.label)
      var d = locationConvertion

      object = {
        skills: a,
        sector: b,
        specialisation: c,
        workplace_type: workplaceType,
        location: d,
        job_type: jobTypee,
        work_schedule: schedule,
        job_status: ["opened"],
        plan: ["Basic", "Premium", "Platinum"],
        search_text: type === "search" ? searchInput : ''
      }
    } else {
      object = {
        skills: [],
        sector: [],
        specialisation: [],
        workplace_type: [],
        location: [],
        job_type: [],
        work_schedule: [],
        job_status: ["opened"],
        plan: ["Basic", "Premium", "Platinum"],
        search_text: type === "search" ? searchInput : ''
      }
    }

    setFilteringObject(object)
    setapplyFilterResponse(true)
    professionalMellieSearch(object)
    if (type === "clear") {
      setIsSearched(false)
      setprofessionalJobClearing(false)
    }

  }

  // const handle 
  const handleResetData = () => {
    setSearchInput("")
    setSortBy("")
    setSelectedCardIndex(0)
    setRefreshAction(false)
    setGettingResponse(false);
    setCardArray([]);
    setAnswer([]);
    setSelectedCardData([]);
    setCardArrayDuplicate([]);
    setCardArrayDuplicateSearch([]);
  }

  // JOY RIDE 
  const steps = [
    {
      // title: "create page",
      target: 'body',
      content: <div className="text-start">
        <h4>Professional Page</h4>
        <p>Welcome to your Profile Page. This is where you can manage all your personal information. Keeping your profile up-to-date helps us provide you with the best job matches.</p>
      </div>,
      placement: "center"
    },
    {
      // title: "create page",
      target: '#allJobsTab',
      content: <div className="text-start">
        <h4>Professional Page</h4>
        <p>Welcome to your Profile Page. This is where you can manage all your personal information. Keeping your profile up-to-date helps us provide you with the best job matches.</p>
      </div>,
      placement: "bottom"
    },

    {
      // title: "create page",
      target: '#recommendedTab',
      content: <div className="text-start">
        <h4>Professional Page</h4>
        <p>Welcome to your Profile Page. This is where you can manage all your personal information. Keeping your profile up-to-date helps us provide you with the best job matches.</p>
      </div>,
      placement: "bottom"
    },
    {
      // title: "create page",
      target: '#appliedTab',
      content: 'Here, you can upload your resume. By uploading your resume, you can auto-fill your profile information, saving you time and effort.',
      placement: "top"
    },
    {
      // title: "create page",
      target: '#savedTab',
      content: <div className="text-start">
        <h4>Professional Page</h4>
        <p>Welcome to your Profile Page. This is where you can manage all your personal information. Keeping your profile up-to-date helps us provide you with the best job matches.</p>
      </div>,
      placement: "bottom"
    },
  ];

  const [run, setRun] = useState(false);
  useEffect(() => {
    setRun(true)
  }, [])


  return (
    <div className="container-fluid dashboard-menus-container">
      {
        (isSelectedJob || isSharedJob) && isSmallDevice ?
          <div className="backbutton-height d-flex align-items-end">
            <button className="btn btn-outline-secondary d-flex align-items-center gap-2 ms-1" onClick={() => {
              setIsSharedJob(false)
              setIsSelectedJob(false)
              pageRender(selectedCardPath)
            }}>
              <IoChevronBackCircle className="fs-5" /> Back
            </button>
          </div>
          :
          <div className="row px-0 px-sm-2 pt-4 ">
            <div className="col-lg-6 px-0">
              <ul className="nav justify-content-around bg-white m-1 rounded-3 select-category filter-side-butons">
                <li
                  className="nav-item navigation-link-active"
                  data-testid="All"
                  id="allJobsTab"
                >
                  {
                    gettingResponse === false ? <label className="py-1"><span className="placeholder rounded px-4 px-md-5 py-3"></span></label>
                      :
                      <NavLink to='/professional/all_jobs' className="nav-link px-1" onClick={window.location.pathname !== '/professional/all_jobs' ? handleResetData : null} >
                        All Jobs
                      </NavLink>
                  }
                </li>
                <li className="nav-item navigation-link-active" data-testid="Recommended" id="recommendedTab">
                  {
                    gettingResponse === false ? <label className="py-1"><span className="placeholder rounded px-4 px-md-5 py-3"></span></label>
                      :
                      <NavLink to="/professional/recommended_jobs" className="nav-link px-1" onClick={window.location.pathname !== '/professional/recommended_jobs' ? handleResetData : null}>
                        Recommended
                      </NavLink>
                  }
                </li>
                <li className="nav-item navigation-link-active" data-testid="Applied" id="appliedTab">
                  {
                    gettingResponse === false ? <label className="py-1"><span className="placeholder rounded px-4 px-md-5 py-3"></span></label>
                      :
                      <NavLink to="/professional/applied_jobs" className="nav-link px-1" onClick={window.location.pathname !== '/professional/applied_jobs' ? handleResetData : null}>
                        Applied
                      </NavLink>
                  }
                </li>
                <li className="nav-item navigation-link-active" data-testid="Saved" id="savedTab">
                  {
                    gettingResponse === false ? <label className="py-1"><span className="placeholder rounded px-4 px-md-5 py-3"></span></label>
                      :
                      <NavLink to="/professional/saved_jobs" className="nav-link px-1" onClick={window.location.pathname !== '/professional/saved_jobs' ? handleResetData : null}>
                        Saved
                      </NavLink>
                  }
                </li>
              </ul>
            </div>

            <div className="col-lg-6 px-0">
              {
                gettingResponse === false ? <label className="py-2 col-12 mt-1"><span className="placeholder rounded w-100 py-3"></span></label>
                  :
                  <div className="d-flex m-1 position-relative">
                    <InputGroup
                      className="home-search-icon fs-5"
                      reIcons={<IoIosSearch />}
                    />

                    <input
                      type="text"
                      className="form-control form-control-lg searchInput border-0 px-5"
                      placeholder="Search by job title, description, company name"
                      aria-label="default input example"
                      id="professionalHomeSearch"
                      value={searchInput}
                      onChange={handleSearchInput}
                      onKeyDown={handlekeydown}
                    />

                    <div className="professional-search-box-button-absolute">
                      {
                        professionalJobSearching ?
                          <button type="button" className="btn btn-brand-color me-2 pe-none">Searching</button>
                          :
                          <button type="button" className="btn btn-brand-color me-2" onClick={handleSearchUsingApi}>Search</button>
                      }

                      {
                        isSearched ?
                          professionalJobClearing ?
                            <button type="button" className="btn btn-brand-color">Clearing</button>
                            :
                            <button type="button" className="btn btn-brand-color" onClick={handleClearSearch}>Clear</button>
                          :
                          null
                      }

                    </div>

                  </div>
              }
            </div>
          </div>
      }

      <Joyride
        styles={{
          options: {
            width: '500px',
            borderRadius: "60px"
          },
          buttonNext: {
            background: '#e38212',
            outline: 'none'
          },
          buttonSkip: {
            textDecoration: 'underline'
          },
          buttonBack: {
            color: '#212529',
            backgroundColor: '#fff',
            border: " 0px",
            borderRadius: "4px",
            color: "#000",
            cursor: "pointer",
            fontSize: "16px",
            lineHeight: "1",
            padding: "8px",
            appearance: "none",
            outline: "1px solid grey",
          }
        }}
        scrollOffset={300}
        continuous
        hideCloseButton
        showSkipButton
        showProgress
        steps={steps}
        run=""
      />
    </div>
  );
};

export default FilterMethods;
